import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'bootstrap/dist/js/bootstrap';
import initImageLazyLoad from './components/imageLazyLoad';
import initLayout from './components/layout';
import initMenu from './components/menu';
import initUserInfo from './components/userInfo';
import initProductSearch from './components/productSearch';
import './styles/main.scss';
import {applyMiddleware, createStore} from "redux";
import rootReducer from "./reducers";
import thunk from "redux-thunk";

initMenu();
initLayout();
initUserInfo();
initImageLazyLoad();
initProductSearch();

export const store = createStore(
  rootReducer,
  applyMiddleware(thunk)
);
